module.exports = __webpack_public_path__ + "img/scene1copy01.90adef7d.png";